export default __webpack_public_path__ + "static/media/bannerImg.c1d8af50.png";